<template>
<div
    style="margin-left: 15px"
>
    <m-faq
        v-if="layer == 'background'"
    >
        <template v-slot:question>What is the purpose of the uncertainty background layer?</template>
        <template v-slot:answer>
            <p>
                If you were asked to guess the sentiment score (percentile) of a bulk message but were told <b>nothing</b> about the recipients, the best guess you could give would be to guess that the outcome would be random (centered around the 50% mark)
            </p>
            <p>
                The uncertainty background layer models this.  This layer makes a prediction knowing <b>nothing</b> about the customer &mdash;  it forecasts that the sentiment will be a gaussian random number taken from a normal distribution with a mean of 50 and a standard devision of 25.
            </p>
            <p>
                Typically this layer is given the lowest possible weight.
            </p>
        </template>
    </m-faq>

    <m-faq>
        <template v-slot:question>What is a sentiment score and how is that calculated?</template>
        <template v-slot:answer>
            The procedure to calculate the <b>raw</b> (non normalized) sentiment score for a bulk message is:
            <ol>
                <li>Send the bulk message</li>
                <li>Wait 7 days</li>
                <li>For every recipient that has placed a non-club order, add one point</li>
                <li>For every recipient that has opted out of messaging, subtract two points</li>
            </ol>

            Raw scores are then translated into percentiles to place a score in context.  For example, if a bulk message has a sentiment score (percentile) of 93, it means that the sentiment score for this bulk message was better than 93% of the sentiment scores for all other bulk messages (across all organizations).

        </template>
    </m-faq>

    <m-faq
        v-if="layer == 'background'"
    >
        <template v-slot:question>What is the meaning of the x-axis?</template>
        <template v-slot:answer>
            <p>
                The x axis (effectively) places every customer at a consistent but random spot.
            </p>
            <p>
                The procedure for doing this is as follows:
                <ol>
                    <li>Take the customer phone number and comptue its MD5 hash</li>
                    <li>Compute the hash's modulus 100 (the remainder when you divide the hash by 100)</li>
                </ol>
            </p>
            <p>
                Effectively, this creates a value from 0 - 99 that is random but will always be the same when computed for a given customer.
            </p>
        </template>
    </m-faq>

    <m-faq
        v-if="layer == 'days-since-last-promotional-message'"
    >
        <template v-slot:question>What happens when a customer has never received a promotional message before?</template>
        <template v-slot:answer>
            <p>
                If a customer has never received a promotional message before, then this layer is dropped from the model for this customer.
            </p>
        </template>
    </m-faq>

    <m-faq
        v-if="layer == 'days-since-last-non-club-purchase'"
    >
        <template v-slot:question>What happens when a customer has never placed a non-club order?</template>
        <template v-slot:answer>
            <p>
                If a customer has never placed a (non-club) order before then this layer is dropped from the model for this customer.
            </p>
        </template>
    </m-faq>

    <m-faq
        v-if="layer == 'bulk-message-order-attribution-percentile'"
    >
        <template v-slot:question>What is bulk message order attribution percentile and how is it calculated?</template>
        <template v-slot:answer>
            <p>
                To calculate a customer's bulk message order attribution percentile you begin by determining the total value of all non-club orders placed by the customer within 7 days of receipt of a promotional bulk message.  This total is then converted into a percentile by comparing it with all of your organization's other customers.
            </p>
            <p>
                For example, if John Smith has a bulk message order attribution percentile of 65 it means that, of <b>all of your customers that have purchased after receiving a bulk message</b>, John spent more (cumulatively) than 65% of the others. 
            </p>
        </template>
    </m-faq>

    <m-faq
        v-if="layer == 'bulk-message-order-attribution-percentile'"
    >
        <template v-slot:question>What happens if a customer has never been sent a promotional bulk message before?</template>
        <template v-slot:answer>
            <p>
                If you have never sent a customer a promotional bulk message before then this layer is dropped from the model for this customer.
            </p>
        </template>
    </m-faq>

    <m-faq
        v-if="layer == 'bulk-message-order-attribution-percentile'"
    >
        <template v-slot:question>What happens if a customer has never placed a (non-club) order after receiving a bulk message?</template>
        <template v-slot:answer>
            <p>
                If you have sent a customer a promotional bulk message before, but they have never placed an attributed, non-club order within 7 days of said message then this layer is dropped from the model for this customer.
            </p>
        </template>
    </m-faq>

    <m-faq
        v-if="layer == 'is-active-club-member'"
    >
        <template v-slot:question>What does the x axis of this chart mean?</template>
        <template v-slot:answer>
            <p>
                Not much -- if a customer is not a club member, then their x value is 1, if they are a club member, then their x value is 99.  All of the middle of the chart is an artifact of model halluciniation (essentially, the model day dreaming about how a customer that has 76% of a membership might behave) &mdash; somewhat fascinating but of no practical value since you either are or are not a member.
            </p>
        </template>
    </m-faq>
</div>
</template>

<script>
export default {
    props: {
        layer: {
            type: String,
            default: function() { return null; }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>